import React, { useEffect, useState } from "react";
import analyticsService from "../services/analytics.service";
import authsService from "../services/auths.service";
import Googlecharts from "../components/Googlecharts";
const Statistics = () => {
  const userinfo = authsService.userinfo();
  const [clientoverviewarr, setClientoverviewarr] = useState([]);
  const [clientoverviewexpense, setClientoverviewexpense] = useState([]);
  const [clientoverviewissue, setClientoverviewissue] = useState([]);
  const [clientoverviewmaintenance, setClientoverviewmaintenance] = useState(
    []
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState("");
  //use effects
  useEffect(() => {
    getallClientoverview();
  }, []);

  //get allclient
  const getallClientoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: "",
      filtermonth: "",
      filteryear: "",
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          const data = [
            ["Name", "total unit"],
            ...res.data.result.data.map((d) => [
              d.client_fullname,
              Number(d.client_total_aircon_unit),
            ]),
          ];
          const data1 = [
            ["Name", "Cost($)"],
            ...res.data.result.data.map((d) => [
              d.client_fullname,
              Number(d.client_total_amount),
            ]),
          ];
          const data2 = [
            ["Name", "Total Issue"],
            ...res.data.result.data.map((d) => [
              d.client_fullname,
              Number(d.client_total_issue),
            ]),
          ];
          const data3 = [
            ["Name", "Total Maintenance"],
            ...res.data.result.data.map((d) => [
              d.client_fullname,
              Number(d.client_total_maintenance + d.client_total_issue),
            ]),
          ];
          setClientoverviewarr(data);
          setClientoverviewexpense(data1);
          setClientoverviewissue(data2);
          setClientoverviewmaintenance(data3);
        } else {
          setClientoverviewarr([]);
        }
      })
      .catch((err) => {
        setClientoverviewarr([]);
      });
  };
  const selectrandomcolor = () => {
    const colors = [
      "#5EE5FA",
      "#5EC4FA",
      "#5E9EFA",
      "#5E73FA",
      "#5EF1FA",
      "#5EFAE0",
      "#605EFA",
    ];

    const random = Math.floor(Math.random() * colors.length);
    return random, colors[random];
  };
  return (
    <div>
      <div>
        <div className="d-flex  mb-2 ">
          <h1 className="flex-fill">Statistics</h1><div>{/* <button
            onClick={() => {
              navigate("/clientevent");
            }}
            type="submit"
            className="btn btn-primary"
          >
            <i className="fa fa-plus"></i> Add Client
          </button> */}</div>
        </div>
        <div className="d-md-flex  mb-2 "></div>
      </div>
      <div className="row">
        <div className="col-md-4 p-1">
          <Googlecharts
            com_data={clientoverviewexpense}
            chart_type="PieChart"
            haxis="Client"
            vaxis="Expenses"
          />
        </div>
        <div className="col-md-8 p-1">
          <Googlecharts
            com_data={clientoverviewarr}
            chart_type="ColumnChart"
            haxis="Client"
            vaxis="Aircon expenses"
          />
        </div>
        <div className="col-md-6 p-1">
          <Googlecharts
            com_data={clientoverviewissue}
            chart_type="AreaChart"
            haxis="Client"
            vaxis="Issue"
          />
        </div>
        <div className="col-md-6 p-1">
          <Googlecharts
            com_data={clientoverviewmaintenance}
            chart_type="AreaChart"
            haxis="Client"
            vaxis="Maintenance"
          />
        </div>
      </div>
    </div>
  );
};

export default Statistics;
